module.exports = __webpack_public_path__ + "img/ENT_Course_2.362e3df8.jpg";